import Vue from 'vue'
const VueShortKey = require('vue-shortkey')

Vue.use(VueShortKey)
